export const TEXT_CONTENT_TYPE = 'TEXT';
export const MARKDOWN_CONTENT_TYPE = 'MARKDOWN';
